// 状态
export const STATUS_CODE = {
  enabled: { label: '是', value: 1 },
  disabled: { label: '否', value: 0 }
}

export function positiveNumValidate(rule, value, callbackFunc) {
  if(value === undefined || value === '' || value === null) {
    callbackFunc();
  } else if(value <= 0) {
    callbackFunc('不可小于等于0')
  }else {
    callbackFunc()
  }
}
